import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'employeeTooltipDownloadDate'
})
export class EmployeeTooltipDownloadDatePipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(value: string): unknown {

    if (value === null) {
      return '';
    }
    return `<div class='text-left'>
    <span class='text-left mgn-bottom-5 d-inline-block'>
    Fecha de desbloqueo: ${this.datePipe.transform(value, 'dd/MM/yyyy')}
    </span></div>`;

  }
}